import { useAppSelector } from '../stores/redux.store';
import type { AwsWafConfig } from '../types';
import { isValidAwsWafConfig } from './aws-captcha.helpers';

/**
 * Returns the AWS WAF config from app state, or `null` when the config is absent or
 * either required field (`integrationUrl`, `apiKey`) is empty.
 */
export const useAwsWafConfig = (): AwsWafConfig | null => {
  const awsWafConfig = useAppSelector(state => state.appConfig.awsWafConfig);

  // Can be empty string for environments that don't have this config
  if (!isValidAwsWafConfig(awsWafConfig)) {
    return null;
  }

  return awsWafConfig;
};
